// extracted by mini-css-extract-plugin
module.exports = {"navLink":"SideMenuSubItem_navLink__2NC3A"};